import { Center, Flex, Text } from '@chakra-ui/react';
import { FC } from 'react';

export const SongChatEmptyState: FC = () => {
  return (
    <Center w="full" h="full">
      <Flex
        direction="column"
        w="218px"
        textAlign="center"
        data-testid="empty-messenger"
      >
        <Text fontSize="md" fontWeight={500}>
          It’s oh so quiet in here
        </Text>
        <Text fontSize="xs" color="textSubdued">
          Start collaborating and I’m sure there will be stuff to talk about.
        </Text>
      </Flex>
    </Center>
  );
};
